package cc.bluepeak.clubmanager.site.styles

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.navigation.LinkStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.selectors.anyLink
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val NavLinkVariant = LinkStyle.addVariant {
    anyLink {
        Modifier
            .textDecorationLine(TextDecorationLine.None)
    }
    base {
        Modifier
            .color(colorMode.toPalette().color)
            .fontWeight(400)
            .fontSize(1.cssRem)
    }
    hover {
        Modifier
            .color(colorMode.toSitePalette().primary)
    }
}

val ButtonLinkVariant = LinkStyle.addVariant(@Composable { ButtonStyle.toModifier() }) {
    anyLink {
        Modifier.color(Theme.white)
            .textDecorationLine(TextDecorationLine.None)
    }
    base {
        Modifier.padding(topBottom = 9.px, leftRight = 1.2.cssRem)
            .height(42.px)
            .alignContent(AlignContent.Center)
    }
}

val SecondaryButtonLinkVariant = LinkStyle.addVariant(@Composable { ButtonStyle.toModifier() }) {
    anyLink {
        Modifier.color(Theme.white)
            .textDecorationLine(TextDecorationLine.None)
    }
    base {
        Modifier.padding(topBottom = 9.px, leftRight = 1.2.cssRem)
            .height(42.px)
            .alignContent(AlignContent.Center)
            .setVariable(ButtonVars.BackgroundDefaultColor, Theme.secondary)
            .setVariable(ButtonVars.Color, Theme.black)
    }
}